import { CountryEntity } from 'api/types/entity';
import { GridFields } from 'components';
import { useStableKeys } from 'hooks';
import { useTranslation } from 'libs/i18n';
import { Stack } from 'libs/ui';
import {
  CountryRiskBadges,
  CountryRiskField,
} from 'modules/client/common/feature';
import {
  useFormContext,
  Field,
} from 'modules/client/common/forms/companyTaxResidencyForm';

import { Header } from './components';

export interface FormContentProps {
  countriesLoading?: boolean;
  countries: CountryEntity[];
  onRemove: (index: number) => void;
}

export const FormContent = ({
  countriesLoading,
  countries,
  onRemove,
}: FormContentProps) => {
  const { t } = useTranslation();
  const { values, readOnly } = useFormContext();

  const taxResidencesKeys = useStableKeys(values.companyTaxResidences);

  return (
    <Stack spacing={32}>
      {values.companyTaxResidences.map((taxResidence, index) => (
        <Stack key={taxResidencesKeys[index]} spacing={24}>
          <Stack spacing={12}>
            <Header index={index} readOnly={readOnly} onRemove={onRemove} />
            <GridFields>
              <Field.Autocomplete
                fullWidth
                showRequiredMark
                label={t('client.client.taxResidency.country.label')}
                loading={countriesLoading}
                name={`companyTaxResidences.${index}.country`}
                optionLabelKey="name"
                options={countries}
                optionValueKey="id"
                placeholder={t(
                  'client.client.taxResidency.country.placeholder'
                )}
                renderOptionRightAdornment={(option) => <CountryRiskBadges
                  country={option as CountryEntity}
                  field={CountryRiskField.CompanyTaxResidence}
                />}
                rightStartElement={
                  <CountryRiskBadges
                    country={taxResidence.country}
                    field={CountryRiskField.CompanyTaxResidence}
                  />
                }
              />
              <Field.Text
                fullWidth
                showRequiredMark
                label={t('client.client.taxResidency.taxNumber.label')}
                name={`companyTaxResidences.${index}.taxNumber`}
                placeholder={t(
                  'client.client.taxResidency.taxNumber.placeholder'
                )}
              />
            </GridFields>
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
};
